var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-field-wr"},[_c('i',{staticClass:"icon-exclamation text-info text-lg"}),_c('span',{staticClass:"ml-1",domProps:{"innerHTML":_vm._s(_vm.htmlData)}})])}
var staticRenderFns = []

export { render, staticRenderFns }